/** Marks a retried SCIT API request so the auth refresh interceptor runs at most once. */
export const API_AUTH_RETRY_HEADER = 'X-SCIT-Auth-Retry';
